
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Example:`}</h3>
    <p>{`Create a yaml file with extension `}<inlineCode parentName="p">{`./example.jxml`}</inlineCode></p>
    <pre {...{
      "className": "language-yaml"
    }}><code parentName="pre" {...{
        "className": "language-yaml"
      }}><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`---`}</span>{`
`}<span parentName="code" {...{
          "className": "token key atrule"
        }}>{`version`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token number"
        }}>{`1.0`}</span>{`

`}<span parentName="code" {...{
          "className": "token key atrule"
        }}>{`state`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`:`}</span>{`
  `}<span parentName="code" {...{
          "className": "token key atrule"
        }}>{`pageTitle`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`:`}</span>{` Page title

`}<span parentName="code" {...{
          "className": "token key atrule"
        }}>{`props`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`:`}</span>{`
  `}<span parentName="code" {...{
          "className": "token key atrule"
        }}>{`title`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`:`}</span>{` Default Button

`}<span parentName="code" {...{
          "className": "token key atrule"
        }}>{`render`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`:`}</span>{`
  `}<span parentName="code" {...{
          "className": "token key atrule"
        }}>{`H1`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`:`}</span>{` this.state.pageTitle
  `}<span parentName="code" {...{
          "className": "token key atrule"
        }}>{`Button`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`:`}</span>{`
    `}<span parentName="code" {...{
          "className": "token key atrule"
        }}>{`style`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`:`}</span>{`
      `}<span parentName="code" {...{
          "className": "token key atrule"
        }}>{`background`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`:`}</span>{` blue
      `}<span parentName="code" {...{
          "className": "token key atrule"
        }}>{`color`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`:`}</span>{` white
      `}<span parentName="code" {...{
          "className": "token key atrule"
        }}>{`padding`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`:`}</span>{` 10px
    `}<span parentName="code" {...{
          "className": "token key atrule"
        }}>{`children`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`:`}</span>{` this.props.title
    `}<span parentName="code" {...{
          "className": "token key atrule"
        }}>{`onClick`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`:`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`|`}</span><span parentName="code" {...{
          "className": "token scalar string"
        }}>{`
      () => {
        this.setState(state=> {
            state.pageTitle = 'Hello World!'
        })
      }`}</span>{`
`}</code></pre>
    <p>{`and then you can import this component to jsx file:`}</p>
    <pre {...{
      "className": "language-jsx"
    }}><code parentName="pre" {...{
        "className": "language-jsx"
      }}><span parentName="code" {...{
          "className": "token keyword module"
        }}>{`import`}</span>{` `}<span parentName="code" {...{
          "className": "token imports"
        }}><span parentName="span" {...{
            "className": "token maybe-class-name"
          }}>{`Example`}</span></span>{` `}<span parentName="code" {...{
          "className": "token keyword module"
        }}>{`from`}</span>{` `}<span parentName="code" {...{
          "className": "token string"
        }}>{`'./example.jxml'`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`;`}</span>{`

`}<span parentName="code" {...{
          "className": "token keyword module"
        }}>{`export`}</span>{` `}<span parentName="code" {...{
          "className": "token keyword module"
        }}>{`default`}</span>{` `}<span parentName="code" {...{
          "className": "token punctuation"
        }}>{`(`}</span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`)`}</span>{` `}<span parentName="code" {...{
          "className": "token arrow operator"
        }}>{`=>`}</span>{` `}<span parentName="code" {...{
          "className": "token tag"
        }}><span parentName="span" {...{
            "className": "token tag"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`<`}</span><span parentName="span" {...{
              "className": "token class-name"
            }}>{`Example`}</span></span>{` `}<span parentName="span" {...{
            "className": "token punctuation"
          }}>{`/>`}</span></span><span parentName="code" {...{
          "className": "token punctuation"
        }}>{`;`}</span>{`
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;